import { SMSMutationTypes } from './types';

export const mutations = {
    [SMSMutationTypes.SetStatus](state, {status}) {
        return state.status = status
    },
    [SMSMutationTypes.SetBalance](state, {balance}) {
        return state.balance = balance
    },
    [SMSMutationTypes.SetSenders](state, {senders}) {
        return state.senders = senders
    },
}
